import * as React from "react";
import MembersStats from "../../presentations/MembersStats";

const MembersStatsContainer = () => {

  const memberStats = {
    members: 1,
    limitedAccessMembers: 2,
    pendingInvites: 3,
    newMembers: 5
  }

  return (
    <div>
      <MembersStats data={memberStats}></MembersStats>
    </div>
  );
};

export default MembersStatsContainer;
